import { render } from "./BrazilFlag.vue?vue&type=template&id=45ba4b60&ts=true"
import script from "./BrazilFlag.vue?vue&type=script&lang=ts"
export * from "./BrazilFlag.vue?vue&type=script&lang=ts"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__